export default __webpack_public_path__ + "static/media/small-logo.353a37ed.svg";